import { isUUID } from '__core/shared/util/validate';
import template from './contactSpouse.template.html';

export default {
  template,
  bindings: {
    currentContact: '<',
    validationErrors: '<',
    isExisting: '<',
    isTicketSettled: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor(
      $timeout,
      $mdUtil,
      Contact,
      contactService,
      contactsService,
      searchService,
      helperService,
      ContactMaritalStatusOption,
      CONTACT,
      uiService
    ) {
      'ngInject';

      const ctrl = this;

      ctrl.initialize = () => {
        ctrl.currentContact = ctrl.currentContact || {};
        ctrl.validationErrors = ctrl.validationErrors || [];
        ctrl.isTicketSettled = ctrl.isTicketSettled || false;

        if (ctrl.isExisting === false) {
          ctrl.isExisting = 'existing';
        } else if (ctrl.isExisting === true) {
          ctrl.isExisting = 'new';
        } else {
          ctrl.isExisting = ctrl.isExisting || '';
        }
        ctrl.contact = {};
        if (
          ctrl.currentContact &&
          ctrl.currentContact.person &&
          ctrl.currentContact.person.information &&
          ctrl.currentContact.person.information.idSpouse &&
          ctrl.currentContact.person.information.idSpouse !== ''
        ) {
          contactService
            .readContact({
              id: ctrl.currentContact.person.information.idSpouse
            })
            .then((data) => {
              if (data) {
                ctrl.contact.id = data.id;
                ctrl.contact.name = data.person.information.firstName;
                ctrl.contact.familyName = data.person.information.familyName;
                ctrl.contact.idSpouse = data.person.information.idSpouse;
              } else {
                ctrl.contact.id = '';
                ctrl.contact.name = '';
                ctrl.contact.familyName = '';
                ctrl.contact.idSpouse = '';
              }
            });
        } else if (_.isUuid(ctrl.isExisting)) {
          contactService.readContact({ id: ctrl.isExisting }).then((data) => {
            if (data) {
              ctrl.contact.id = data.id;
              ctrl.contact.name = data.person.information.firstName;
              ctrl.contact.familyName = data.person.information.familyName;
              ctrl.contact.idSpouse = data.person.information.idSpouse;
              ctrl.updateContact(ctrl.contact);
            } else {
              ctrl.contact.id = '';
              ctrl.contact.name = '';
              ctrl.contact.familyName = '';
              ctrl.contact.idSpouse = '';
            }
          });
        } else {
          ctrl.contact.id = '';
          ctrl.contact.name = '';
          ctrl.contact.familyName = '';
          ctrl.contact.idSpouse = '';
        }
      };

      ctrl.searchTextChange = (text) => {
        ctrl.contact.name = text;
      };

      ctrl.createContact = _.debounce((contactToCreate) => {
        const simpleContact = contactToCreate;
        if (!_.isString(simpleContact?.name)) {
          simpleContact.name = simpleContact?.name?.name || '';
        }
        if (ctrl.searchText && _.isString(ctrl.searchText) && !simpleContact?.name) {
          simpleContact.name = ctrl.searchText;
        }
        contactsService.clearCache();
        let contact = null;

        if (
          _.isString(simpleContact?.name) &&
          simpleContact?.name !== '' &&
          simpleContact?.familyName !== '' &&
          !simpleContact?.id
        ) {
          simpleContact.idSpouse = ctrl.currentContact.id;
          simpleContact.maritalStatus =
            ctrl.currentContact.person.information.maritalStatus.name ===
              ContactMaritalStatusOption.Married.name ||
            ctrl.currentContact.person.information.maritalStatus.name ===
              ContactMaritalStatusOption.DeFacto.name
              ? ctrl.currentContact.person.information.maritalStatus
              : 2;
          contact = Contact.blank();
          contact = ctrl.fillContactFields(contact, simpleContact);
          contact.person.information.spouseFirstName =
            ctrl.currentContact.person.information.firstName;
          contact.person.information.spouseFamilyName =
            ctrl.currentContact.person.information.familyName;
          contact.person.information.useExistingContactAsSpouse = 'new';
          contactService.createContact(contact).then((data) => {
            if (data.status) {
              simpleContact.id = data.id;
              ctrl.currentContact.person.information.idSpouse = simpleContact.id;
              ctrl.currentContact.person.information.spouseFirstName = simpleContact.name;
              ctrl.currentContact.person.information.spouseFamilyName =
                simpleContact.familyName;
              ctrl.currentContact.person.information.useExistingContactAsSpouse = 'new';
              ctrl.finished(ctrl.currentContact, simpleContact);
            }
          });
        }
      }, 2000);

      ctrl.updateContact = _.debounce((contactToCreate) => {
        const simpleContact = contactToCreate;
        if (!_.isString(simpleContact?.name)) {
          simpleContact.name = simpleContact?.name?.name || '';
        }
        if (ctrl.searchText && _.isString(ctrl.searchText) && !simpleContact?.name) {
          simpleContact.name = ctrl.searchText;
        }
        contactsService.clearCache();
        if (
          _.isString(simpleContact?.name) &&
          simpleContact?.name !== '' &&
          simpleContact?.familyName !== '' &&
          simpleContact?.id !== '' &&
          simpleContact?.id !== ctrl.currentContact?.id
        ) {
          ctrl.currentContact.person.information.idSpouse = simpleContact.id;
          ctrl.currentContact.person.information.spouseFirstName = simpleContact.name;
          ctrl.currentContact.person.information.spouseFamilyName = simpleContact.familyName;
          ctrl.currentContact.person.information.useExistingContactAsSpouse = ctrl.isExisting;
          contactService
            .updateContact({
              id: simpleContact.id,
              isCompany: false,
              person: {
                information: {
                  firstName: simpleContact.name,
                  familyName: simpleContact.familyName,
                  maritalStatus: ctrl.currentContact.person.information.maritalStatus,
                  idSpouse: ctrl.currentContact.id,
                  spouseFirstName: ctrl.currentContact.person.information.firstName,
                  spouseFamilyName: ctrl.currentContact.person.information.familyName,
                  useExistingContactAsSpouse: _.isUuid(ctrl.isExisting)
                    ? ctrl.currentContact.id
                    : ctrl.isExisting
                }
              }
            })
            .then((data) => {
              if (data.status) {
                ctrl.finished(ctrl.currentContact, simpleContact);
              }
            });
        } else if (
          simpleContact?.id !== '' &&
          ctrl.currentContact?.person?.information?.idSpouse !== '' &&
          simpleContact?.id !== ctrl.currentContact?.id
        ) {
          simpleContact.idSpouse = '';
          ctrl.currentContact.person.information.idSpouse = '';
          const { spouseFirstName } = ctrl.currentContact?.person?.information;
          const { spouseFamilyName } = ctrl.currentContact?.person?.information;
          const maritalStatus = ContactMaritalStatusOption.Divorced;
          ctrl.currentContact.person.information.maritalStatus = maritalStatus;
          ctrl.currentContact.person.information.spouseFirstName = '';
          ctrl.currentContact.person.information.spouseFamilyName = '';
          ctrl.currentContact.person.information.useExistingContactAsSpouse = '';
          contactService
            .updateContact({
              id: simpleContact.id,
              isCompany: false,
              person: {
                information: {
                  firstName: spouseFirstName,
                  familyName: spouseFamilyName,
                  maritalStatus: ContactMaritalStatusOption.Divorced,
                  useExistingContactAsSpouse: '',
                  idSpouse: '',
                  spouseFirstName: '',
                  spouseFamilyName: ''
                }
              }
            })
            .then((data) => {
              if (data.status) {
                ctrl.finished(ctrl.currentContact, simpleContact);
              }
            });
        } else if (simpleContact?.id === ctrl.currentContact?.id) {
          uiService.toast({
            text: {
              p1: 'Contact',
              p2: `${ctrl.currentContact?.person?.information?.firstName} ${ctrl.currentContact?.person?.information?.familyName}`,
              p3: 'cannot be added as spouse to himself'
            },
            warn: true
          });
          simpleContact.id = '';
          simpleContact.name = '';
          simpleContact.familyName = '';
          simpleContact.idSpouse = '';
          simpleContact.maritalStatus = '';
        }
      }, 2000);

      ctrl.finished = (contact, selectedSpouse) => {
        contactService.readContact({ id: selectedSpouse.id }).then((spouse) => {
          if (spouse) {
            ctrl.onFinished({ contact, spouse });
          }
        });
      };

      ctrl.fillContactFields = (contactToFill, simpleContact) => {
        const contact = contactToFill;
        contact.id = simpleContact.id;
        contact.person.information.firstName = simpleContact.name;
        contact.person.information.familyName = simpleContact.familyName;
        contact.person.information.idSpouse = simpleContact.idSpouse;
        contact.person.information.maritalStatus = simpleContact.maritalStatus;
        return contact;
      };

      ctrl.selectedItemChange = (selectedContact) => {
        if (selectedContact && selectedContact.id) {
          contactService.readContact({ id: selectedContact.id }).then((data) => {
            const contact = data;
            if (contact && contact.id && !contact.person.information.idSpouse) {
              ctrl.contact.id = contact.id;
              ctrl.contact.name = contact.person.information.firstName;
              ctrl.contact.familyName = contact.person.information.familyName;
              ctrl.contact.idSpouse = ctrl.currentContact.id;
              ctrl.contact.maritalStatus = ctrl.currentContact.person.information.maritalStatus;
              ctrl.updateContact(ctrl.contact);
            } else {
              ctrl.contact.id = '';
              ctrl.contact.name = '';
              ctrl.contact.familyName = '';
              ctrl.contact.idSpouse = '';
              ctrl.contact.maritalStatus = '';
              uiService.toast({
                text: {
                  p1: 'Contact',
                  p2: `${contact.person.information.firstName} ${contact.person.information.familyName}`,
                  p3: 'has been already added as spouse'
                },
                warn: true
              });
            }
          });
        }
      };

      ctrl.searchContact = (query) => searchService.getContacts({ query, isCompany: false });

      ctrl.isGuid = () => isUUID(ctrl.isExisting);

      ctrl.hasValidationError = ({ path }) =>
        helperService.hasValidationError({ errors: ctrl.validationErrors, path });

      ctrl.$onInit = () => {
        ctrl.initialize();
      };

      ctrl.$onChanges = (changes) => {
        if (changes.isExisting) {
          $timeout(() => {
            ctrl.initialize();
          }, 1500);
        }
      };
    }
  }
};
